import {
	ClientPortfolioInvestmentFrequencyEnum,
	ClientPortfolioInvestmentTypeEnum,
	type PortfolioDetailResponseDTO,
} from "web_myplann/Infrastructure/Api/Api";
import {
	KINDS_WITH_PURCHASE_INSTRUCTIONS,
	type NormalizedTool,
} from "web_myplann/Portfolio/Helpers/investmentToolTypes";
import { normalizeTools } from "web_myplann/Portfolio/Helpers/normalizeTools";

export const getIsActive = (
	startAt: string | undefined | null,
	endAt: string | undefined | null,
	isOneTime: boolean,
) => {
	const now = new Date();
	const startDate = startAt ? new Date(startAt) : now;

	const todayDateOnly = new Date(
		now.getFullYear(),
		now.getMonth(),
		now.getDate(),
	);
	const startDateOnly = new Date(
		startDate.getFullYear(),
		startDate.getMonth(),
		startDate.getDate(),
	);

	if (isOneTime) {
		return todayDateOnly.getTime() === startDateOnly.getTime();
	}

	const hasStarted = startDateOnly <= todayDateOnly;

	if (!endAt) {
		return hasStarted;
	}

	const endDate = new Date(endAt);
	const endDateOnly = new Date(
		endDate.getFullYear(),
		endDate.getMonth(),
		endDate.getDate(),
	);

	return hasStarted && todayDateOnly <= endDateOnly;
};

export const toolHasActivePeriodicPurchaseInstructions = (
	tool: NormalizedTool,
): boolean => {
	if (!KINDS_WITH_PURCHASE_INSTRUCTIONS.includes(tool.kind)) {
		return false;
	}

	return tool.instructions.some((instruction) => {
		const isOneTime =
			instruction.frequency === ClientPortfolioInvestmentFrequencyEnum.Once;
		const isPurchase =
			instruction.investmentType === null ||
			instruction.investmentType === ClientPortfolioInvestmentTypeEnum.Buy;
		const isActive = instruction.startAt
			? getIsActive(instruction.startAt, instruction.endAt, isOneTime)
			: false;

		return !isOneTime && isPurchase && isActive;
	});
};

export const hasActivePeriodicPurchaseInstructions = (
	baseData: PortfolioDetailResponseDTO,
): boolean =>
	normalizeTools(baseData.tools).some((tool) =>
		toolHasActivePeriodicPurchaseInstructions(tool),
	);
